import React, { useState } from 'react';
import { Alert, Button, Card, Descriptions, Space, Table, Typography, message } from 'antd';
import PageTitle from '../../components/PageTitle';
import { adminRunTodayBillCron } from '../../api';

const { Text } = Typography;

const resultColor = (result) => {
  if (result === 'generated') return 'success';
  if (result === 'error') return 'error';
  return 'warning';
};

const resultLabel = (result) => {
  const map = {
    generated: '已出账',
    skipped_start_before: '跳过-早于入住日',
    skipped_overlap: '跳过-日期重叠',
    skipped_exists: '跳过-账单已存在',
    error: '失败',
  };
  return map[result] || result;
};

const BillCronManual = () => {
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);

  const handleRun = async () => {
    setLoading(true);
    try {
      const res = await adminRunTodayBillCron();
      if (!res?.success) {
        message.error(res?.msg || '执行失败');
        return;
      }
      setReport(res.data || null);
      message.success('执行完成，请查看下方统计');
    } catch (err) {
      const body = err.response?.data;
      message.error(body?.msg || body?.error || err.message || '请求失败');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { title: '规则ID', dataIndex: 'rule_id', width: 80 },
    { title: '房间ID', dataIndex: 'room_id', width: 80 },
    { title: '租客手机', dataIndex: 'zuke_phone', width: 120 },
    { title: '出账日', dataIndex: 'bill_generate_day', width: 70 },
    { title: '入住日', dataIndex: 'start_date', width: 110 },
    { title: '目标账期', dataIndex: 'expected_cycle', width: 180 },
    {
      title: '结果',
      dataIndex: 'result',
      width: 130,
      render: (v) => <Text type={resultColor(v)}>{resultLabel(v)}</Text>,
    },
    { title: '账单号', dataIndex: 'bill_no', width: 160, ellipsis: true },
    { title: '说明', dataIndex: 'message', ellipsis: true },
  ];

  return (
    <div style={{ padding: '20px 0' }}>
      <PageTitle title="今日出账检查" />

      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 16 }}
        message="用途说明"
        description={
          <div>
            <div>点击按钮会<strong>立即按今日日期</strong>执行与凌晨 0 点相同的月度出账逻辑（不经过 cron 并发闸门，不会被「资源保护」跳过）。</div>
            <div style={{ marginTop: 8 }}>
              <Text type="secondary">
                命中规则 = 今日是出账日且首月已生成的活跃规则；应出账 = 通过入住日/重叠/重复检查后需要新建账单；实际出账 = 成功写入数据库的条数。
              </Text>
            </div>
          </div>
        }
      />

      <Card style={{ marginBottom: 16 }}>
        <Space>
          <Button type="primary" loading={loading} onClick={handleRun}>
            手动检查今日需出账账单并出账
          </Button>
          {report && (
            <Text type="secondary">上次执行：{report.run_at}</Text>
          )}
        </Space>
      </Card>

      {report && (
        <>
          <Card title="执行统计" style={{ marginBottom: 16 }}>
            <Descriptions column={2} size="small" bordered>
              <Descriptions.Item label="检查日期">{report.today}（{report.today_day} 号）</Descriptions.Item>
              <Descriptions.Item label="本月最后一天">{report.last_day_of_month} 号</Descriptions.Item>
              <Descriptions.Item label="命中账单规则">
                <Text strong>{report.matched_rule_count}</Text> 条
              </Descriptions.Item>
              <Descriptions.Item label="首月未就绪（同日出账日）">
                <Text type={report.unready_rule_count > 0 ? 'warning' : undefined}>
                  {report.unready_rule_count}
                </Text> 条
              </Descriptions.Item>
              <Descriptions.Item label="应出账">
                <Text strong type="primary">{report.should_generate_count}</Text> 条
              </Descriptions.Item>
              <Descriptions.Item label="实际出账">
                <Text strong type={report.generated_count > 0 ? 'success' : 'danger'}>
                  {report.generated_count}
                </Text> 条
              </Descriptions.Item>
              <Descriptions.Item label="跳过">{report.skipped_count} 条</Descriptions.Item>
              <Descriptions.Item label="失败">{report.failed_count} 条</Descriptions.Item>
            </Descriptions>
          </Card>

          <Card title="规则明细">
            <Table
              rowKey={(r) => `${r.rule_id}-${r.expected_cycle || r.result}`}
              size="small"
              columns={columns}
              dataSource={report.details || []}
              pagination={{ pageSize: 20, showSizeChanger: true }}
              scroll={{ x: 1100 }}
            />
          </Card>
        </>
      )}
    </div>
  );
};

export default BillCronManual;
